import {Component} from 'react';

export class Main extends Component {

	render() {
		return (
      'Hello World!'
		);
	}
}